// extracted by mini-css-extract-plugin
export default {"placeholder":"_8gS6mMxipHz7mAFCGrxcEg=="};